export default __webpack_public_path__ + "static/media/bc-second.511cfe82.svg";